var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChestPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 108,
    viewBox: "0 0 324 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4430_201980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.38 18.2776H237.444C235.46 16.2193 233.452 14.1364 232.344 12.9863H92.3471C91.3764 13.9933 89.2639 16.1848 87.2464 18.2776H25.3155C21.9706 21.7475 20.0959 23.6923 16.751 27.1622V78.2833L25.3155 87.1679H299.38C302.725 83.698 304.6 81.7533 307.944 78.2833V27.1622C304.6 23.6923 302.725 21.7475 299.38 18.2776Z",
    fill: "url(#paint0_radial_4430_201980)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4430_201980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.0142 23.2052C92.0142 23.2052 94.0649 21.0729 97.1053 17.9238H227.581C229.727 20.1499 230.526 20.9791 232.672 23.2052H92.0142Z",
    fill: "#5CDCFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4430_201980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.187 75.0059C301.312 76.8025 300.479 77.6959 296.092 82.2468H28.5987C24.2117 77.6959 25.8913 79.5568 21.5044 75.0059",
    stroke: "#6B2FDD",
    strokeWidth: 0.733377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4430_201980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.622 23.1992H296.092C300.479 27.7501 298.8 26.0176 303.187 30.5685",
    stroke: "#7C47FC",
    strokeWidth: 0.733377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_4430_201980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5088 30.6129C25.8957 26.062 24.2161 27.7501 28.6031 23.1992H82.9972",
    stroke: "#7C47FC",
    strokeWidth: 0.733377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4430_201980",
    x: 0.750977,
    y: 0.986328,
    width: 323.193,
    height: 106.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.917647 0 0 0 0 0.87451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4430_201980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4430_201980",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4430_201980",
    x: 90.0585,
    y: 15.9682,
    width: 144.569,
    height: 9.19259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4430_201980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4430_201980",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4430_201980",
    x: 19.182,
    y: 72.684,
    width: 286.327,
    height: 11.885,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4430_201980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4430_201980",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4430_201980",
    x: 239.3,
    y: 20.8773,
    width: 66.2092,
    height: 12.0139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4430_201980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4430_201980",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_4430_201980",
    x: 19.1864,
    y: 20.8773,
    width: 66.133,
    height: 12.0578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4430_201980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4430_201980",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4430_201980",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.526 38.7377) scale(197.407 79.8663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E429C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1C3F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#183889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#112D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#081D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001038"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4430_201980",
    x1: 188.5,
    y1: 39,
    x2: 188.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6064FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChestPanel);
export default __webpack_public_path__ + "static/media/chest-panel.c65f33cb10e638a8b4737b3a862be966.svg";
export { ForwardRef as ReactComponent };